<ng-container *transloco="let t">
  <ng-container *ngIf="container">
    <div class="p-d-flex p-jc-between">
      <div class="p-d-flex">
        <div class="time">
          {{ container.time | timezoneTime | amDateFormat: 'HH:mm' }}
          <span class="timezone-times">({{ container.time | amDateFormat: 'HH:mm' }})&nbsp;</span>
          <div *ngIf="container?.exercise?.isActive === true" class="marker"></div>
        </div>
        <div class="name" [class.strong]="type === 'exercise'" [ngSwitch]="type">
          <ng-container *ngSwitchCase="'org'">{{ title }}</ng-container>
          <ng-container *ngSwitchCase="'break'">{{ title }}</ng-container>
          <ng-container *ngSwitchCase="'conference'">
            <ng-container *ngIf="!canOpenConference()">{{ title }}</ng-container>
            <a *ngIf="canOpenConference()" routerLink="/ac/conference">{{ title }}</a>
          </ng-container>
          <ng-container *ngSwitchCase="'exercise'">
            <strong>
              {{ title }}
              <div *ngIf="auth.isModerator() && !container?.exercise?.allCandidatesLinked" class="not-linked-marker">
                <i class="pi pi-exclamation-triangle p-ml-2" [pTooltip]="t('common.labels.not_all_candidates_linked')"></i>
              </div>
            </strong>
            <ng-container *ngIf="group === true">
              <span *ngIf="team === true">{{ t('common.labels.team_exercise') }}</span>
              <span *ngIf="team !== true">{{ t('common.labels.individual_exercise') }}</span>
            </ng-container>
            <span *ngIf="container.part">{{ t('common.labels.part') }} {{ container.part }}</span>
          </ng-container>
        </div>
        <div>
          <app-agenda-participant-icons
            *ngIf="type !== 'exercise'"
            [slot]="container.slots[0]"
          ></app-agenda-participant-icons>
        </div>
      </div>
      <div *ngIf="type === 'exercise'" class="controls">
        <button *ngIf="auth.isModerator()" pButton type="button" class="p-button-sm p-ml-1" (click)="data.openExerciseSettings(container?.exercise?.id, 'settings')" icon="pi pi-sliders-h" pTooltip="{{ t('common.labels.settings') }}" tooltipPosition="bottom"></button>
        <button *ngIf="container?.opened !== true" pButton type="button" class="p-button-sm p-button-secondary p-button-text p-ml-1" (click)="openContainer(container)" icon="pi pi-chevron-down" pTooltip="{{ t('common.labels.expand') }}" tooltipPosition="bottom"></button>
        <button *ngIf="container?.opened === true" pButton type="button" class="p-button-sm p-button-secondary p-button-text p-ml-1" (click)="closeContainer(container)" icon="pi pi-chevron-up" pTooltip="{{ t('common.labels.collapse') }}" tooltipPosition="bottom"></button>
      </div>
      <div *ngIf="auth.isModerator() && type === 'conference'" class="p-grid conference">
        <div class="p-col">
          <app-timer [slot]="container.slots[0]"></app-timer>
        </div>
        <div class="p-col">
          <app-controls-slot [slot]="container.slots[0]"></app-controls-slot>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
